import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import TopNav from '../../components/TopNav';
import Footer from '../../components/Footer';
import CatchImage from '../../images/catch/catch_faq.jpg';
import CatchImage2x from '../../images/catch/catch_faq@2x.jpg';
import { useScrollToAnchor } from '../../hooks/useScrollToAnchor';
import { useTitle } from '../../hooks/useTitle';
import { useMetaDescription } from '../../hooks/useMetaDescription';

const FaqPage: React.FC = () => {
  const { scrollToAnchor } = useScrollToAnchor();

  useTitle('Ton Bébé | よくある質問');
  useMetaDescription('Ton Bébéのよくある質問。サービス内容、メッセージのやり取り、本人確認、性病・精液検査結果の登録方法など、ご利用にあたっての疑問にお答えします。');

  useEffect(() => {
    scrollToAnchor();
  }, [scrollToAnchor]);

  return (
    <>
      <header>
        <TopNav />
        <div className="catch sub">
          <img
            src={ CatchImage }
            srcSet={ `${ CatchImage } 1x, ${ CatchImage2x } 2x` }
            alt="よくある質問"
          />
        </div>
      </header>
      <main className="sub">
        <section className="faq">
          <h1 className="sec_title">よくある質問</h1>

          <nav className="faq_toc">
            <ul>
              <li><a href="#faq-about">Ton Bébéについて</a></li>
              <li><a href="#faq-message">メッセージについて</a></li>
              <li><a href="#faq-kyc">本人確認について</a></li>
              <li><a href="#faq-checkup">書類審査・検査結果について</a></li>
              <li><a href="#faq-profile">プロフィールについて</a></li>
              <li><a href="#faq-account">アカウントについて</a></li>
            </ul>
          </nav>

          <h2 id="faq-about" className="main_title"><span>Ton Bébéについて</span></h2>
          <ul className="text_list">
            <li>
              <h4 className="sub_title"><span>Q</span>Ton Bébéとは何ですか？</h4>
              <p>LGBT、FTM、選択的シングルマザーなど、子供を望む女性が安心して精子ドナーを探すことができる、精子提供マッチングサービスです。性病検査や精液検査の結果からドナーを検索することができます。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>無料で利用できますか？</h4>
              <p>Ton Bébéは無料でご利用いただけます。</p>
              <p>ドナーをお探しの方は、ドナーへの謝礼や交通費などの実費負担がかかりますが、ドナーによっては受け取らない方もおります。事前にメッセージをやりとりして両者間で決めましょう。
              </p>
              <p>ドナーの方は、性病・精液検査結果の登録に、それぞれ3,000円（両方同時の場合は5,000円）を手数料としてお支払いいただきます。ただし、検査結果を登録しないでドナーとして登録することも可能です。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>登録したことが周囲に知られることはありますか？</h4>
              <p>Ton Bébéではお預かりした個人情報は厳重に管理しております。また、FacebookなどSNS連携でログインした場合でも、投稿や友人へ知られることはありませんのでご安心ください。</p>
            </li>
          </ul>

          <h2 id="faq-message" className="main_title"><span>メッセージについて</span></h2>
          <ul className="text_list">
            <li>
              <h4 className="sub_title"><span>Q</span>ドナー登録したけどメッセージが届きません。何をすれば良いですか？</h4>
              <p>Ton Bébéでは、ドニー（女性）が条件に合うドナーを検索してメッセージを送信する流れになります。メッセージを受信した際にはご登録のメールアドレスに通知のメールが送信されます。</p>
              <p>より多くのメッセージを受け取るために、以下をお試しください。</p>
              <p>
                ・本人確認を完了させる — 本人確認が済んでいるドナーはドニーからの信頼を得やすくなります。<br/>
                ・性病・精液検査結果を登録する — 検査結果を登録しているドナーはドニーが検索で絞り込みやすく、メッセージを受け取りやすくなります。<br/>
                ・プロフィールを充実させる — 「精子提供を行う理由」など精子提供への想いを記載されているドナーのほうが多くのメッセージを受け取っております。
              </p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>メッセージを送ったのに返信がありません</h4>
              <p>ドナーが多忙な場合や、長期間ログインしていない場合があります。しばらく待っても返信がない場合は、他のドナーへのメッセージをご検討ください。</p>
              <p>最終ログインが新しいドナーは比較的メッセージの返信が早く、返信率も高い傾向にあります。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>ドニーからのメッセージを断っても大丈夫ですか？</h4>
              <p>はい、問題ありません。メッセージへの返信や精子提供を行うかどうかはドナーご自身でご判断ください。断る場合はその旨をメッセージでお伝えいただければ幸いです。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>誤ってメッセージ（会話）を消してしまいました。復元できますか？</h4>
              <p>メッセージの「削除」は非表示にする操作ですので、復元が可能です。<Link to="/mypage/messages" className="txt_blue">メッセージページ</Link>（要ログイン）で「非表示の会話も表示する」にチェックを入れると、非表示にした会話を再度ご確認いただけます。</p>
              <p>会話を開いて「この会話を再表示する」を選択すると、常に表示される状態に戻ります。</p>
            </li>
          </ul>

          <h2 id="faq-kyc" className="main_title"><span>本人確認について</span></h2>
          <ul className="text_list">
            <li>
              <h4 className="sub_title"><span>Q</span>本人確認とは何ですか？なぜ必要ですか？</h4>
              <p>本人確認とは、ご本人様であることを確認する手続きです。Ton Bébéでは安全なマッチング環境を提供するため、全ユーザーに本人確認をお願いしております。</p>
              <p>メッセージの返信や提供実績の承認などには本人確認が必須になります。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>本人確認には何が必要ですか？</h4>
              <p>以下のいずれかの公的身分証明書が必要です。</p>
              <p>・運転免許証（表面・裏面の画像）<br/>・マイナンバーカード（表面の画像）<br/>・在留カード（表面・裏面の画像）</p>
              <p>書類の券面情報が全て読み取れる状態で画像をアップロードしてください。また、生年月日の入力も必要です。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>本人確認の審査にどれくらい時間がかかりますか？</h4>
              <p>通常、提出から3営業日以内に審査結果をお知らせします。審査状況は本人確認ページでご確認いただけます。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>ドニーもメッセージの返信に本人確認が必要ですか？</h4>
              <p>はい。ドナー・ドニーともに、メッセージの送信・返信には本人確認が必要です。すべてのユーザー様に安心してご利用いただくための措置ですので、ご理解のほどよろしくお願いいたします。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>ドニーの本人確認書類は、実際に提供を受ける本人以外でも良いですか？</h4>
              <p>本人確認は、実際に精子提供を受けるご本人様（女性）の書類をご提出ください。パートナーの方がドナーとのメッセージのやり取りの窓口となること自体は問題ございませんが、ご提出いただく身分証明書はご本人様のものに限ります。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>本人確認書類をアップロードしようとするとエラーになります</h4>
              <p>生年月日が未入力の場合、書類の提出が完了できません。<Link to="/mypage/kyc" className="txt_blue">本人確認ページ</Link>（要ログイン）で生年月日をご入力のうえ、再度お試しください。</p>
              <p>それでも解決しない場合は、画像の形式（jpg・jpeg・gif・png）とファイルサイズをご確認ください。</p>
            </li>
          </ul>

          <h2 id="faq-checkup" className="main_title"><span>書類審査・検査結果について</span></h2>
          <ul className="text_list">
            <li>
              <h4 className="sub_title"><span>Q</span>性病・精液検査を行う検査機関の指定はありますか？</h4>
              <p>検査機関の指定はありません。ただし、以下の検査項目は登録時に入力必須となっております。</p>
              <p>【性病検査】<br/>・HIV<br/>・梅毒<br/>・クラミジア<br/>・淋菌
              </p>
              <p>【精液検査】<br/>・精液量<br/>・精子濃度<br/>・総精子数
              </p>
              <p>※上記以外でも検査結果書類に記載の項目は全てご入力いただいております。<br/>
                ※上記必須項目は仕様により変更になることがありあます。
              </p>
              <p>ほとんどの検査機関・検査キットで上記項目は対応しておりますが、<Link to="/to_be_donor">Ton Bébéおすすめの検査キットはこちら</Link>をご覧ください。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>性病・精液検査結果は信頼できますか？</h4>
              <p>Ton Bébéではドナーが検査結果を登録する際に、証明書を提出していただいております。その内容をTon Bébé運営事務局にて検証の上、正しい検査結果をサイト上に表示しておりますので、安心してご利用ください。
              </p>
              <p>ただし、より新しい検査結果をドナーがお持ちの場合もありますので、面談時に必ずご自身の目で確認するようにしてください。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>検査結果を登録するにはどんな書類が必要ですか？</h4>
              <p>医療機関または検査キットが発行した性病検査・精液検査の結果証明書が必要です。書類をアップロード後、Ton Bébé運営事務局が内容を確認します。なお、必須の検査項目については「性病・精液検査を行う検査機関の指定はありますか？」をご覧ください。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>書類の審査にどれくらい時間がかかりますか？</h4>
              <p>通常、提出から3営業日以内に審査結果をお知らせします。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>検査結果には有効期限がありますか？</h4>
              <p>検査日から6ヶ月以内の検査結果のみご登録いただけます。それを超える場合は、お手数ですが再検査のうえ再登録をお願いいたします。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>保健所で受けた匿名の検査結果でも登録できますか？</h4>
              <p>ご本人様が受けられた検査結果であれば、匿名の保健所の検査結果でもご登録いただけます。</p>
            </li>
            <li>
              <h4 className="sub_title" id="help-sperm-calc"><span>Q</span>精子品質とはなんですか？</h4>
              <p>Ton Bébéでは、精液検査結果を５段階（A〜E）で表しています。<br/>WHO（世界保健機関）が発表した、以下の一般成人男性の精液検査のデータを基に、計算しています。</p>
              <div className="scroll">
                <table>
                  <thead>
                    <tr>
                      <th>パーセンタイル</th>
                      <th>5</th>
                      <th>25</th>
                      <th>50</th>
                      <th>90</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>精液量（ml）</td>
                      <td>1.2</td>
                      <td>2.2</td>
                      <td>3.2</td>
                      <td>5.5</td>
                    </tr>
                    <tr>
                      <td>精子濃度（10/ml）</td>
                      <td>9</td>
                      <td>36</td>
                      <td>64</td>
                      <td>192</td>
                    </tr>
                    <tr>
                      <td>総精子数（10 ）</td>
                      <td>20</td>
                      <td>101</td>
                      <td>196</td>
                      <td>619</td>
                    </tr>
                    <tr>
                      <td>運動率（％）</td>
                      <td>36</td>
                      <td>55</td>
                      <td>62</td>
                      <td>85</td>
                    </tr>
                    <tr>
                      <td>正常形態率（％）</td>
                      <td>4.7</td>
                      <td>10.5</td>
                      <td>14</td>
                      <td>23.2</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>出典: <a href="https://pubmed.ncbi.nlm.nih.gov/19934213/">World Health Organization reference values for human semen
                  characteristics</a></p>
              <p>各検査項目について、パーセンタイルを 5, 25, 50, 90 で区切り、<br/>A : 90以上<br/>B : 50以上<br/>C : 25以上<br/>D : 5以上<br/>E :
                5未満<br/>として算出し、それらの平均値を「精子品質」として表示しています。</p>
            </li>
          </ul>

          <h2 id="faq-profile" className="main_title"><span>プロフィールについて</span></h2>
          <ul className="text_list">
            <li>
              <h4 className="sub_title"><span>Q</span>プロフィール写真は必須ですか？</h4>
              <p>プロフィール写真は必須ではありません。ただし、写真を登録しているドナーのほうがドニーからのメッセージを受け取りやすい傾向がありますので、登録をお勧めしております。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>プロフィール写真の公開先は制限できますか？</h4>
              <p>できません。プロフィール写真はログインしていない方を含む全ての方に公開されますのでご留意ください。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>プロフィール写真を登録したのに表示されません</h4>
              <p>プロフィール写真は、性病検査または精液検査の結果が承認済みのドナー様のみ表示される仕様となっております。検査結果をご登録のうえ、審査の完了をお待ちください。</p>
              <p>また、トップページなどの「性病検査済みおすすめドナー」は表示速度改善のため一定時間キャッシュされます。写真を差し替えた直後に古い写真が表示される場合は、しばらく時間をおいてからご確認ください。プロフィール詳細ページには最新の写真が反映されております。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>「性病検査済みおすすめドナー」に表示される仕組みを教えてください</h4>
              <p>本人確認・性病検査結果の登録が承認済みで、プロフィールを公開されているドナー様の中から、システムがランダムに選出し、一定時間ごとに自動更新しています。</p>
              <p>特定のドナー様を優遇する設定はなく、選出条件の詳細はサービスの公平性・健全性を守るため非公開とさせていただいております。検査結果の再登録や退会・再登録によって表示されやすくなることもありません。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>国籍や人種でドナーを絞り込めますか？</h4>
              <p><Link to="/search" className="txt_blue">ドナー検索ページ</Link>の検索条件から絞り込みが可能です。国籍は「日本」「日本以外」の2区分、人種は「日本人」「東アジア」「他のアジア」「白人系」「アフリカ系」「ヒスパニック系」「混血」「その他」の区分でお選びいただけます。</p>
              <p>特定の国名での絞り込みには対応しておりませんので、詳細はドナーのプロフィールをご確認いただくか、メッセージにてお尋ねください。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>提供実績はどのように登録すればいいですか？</h4>
              <p>まずドナー様が<Link to="/mypage/records" className="txt_blue">提供実績ページ</Link>（要ログイン）から提供実績を登録します。登録すると、お相手のドニー様に承認依頼の通知が届き、ドニー様が同じく提供実績ページから「承認」を行うことで、実績として反映されます。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>誤って提供実績を登録してしまいました。取り消せますか？</h4>
              <p>お相手のドニー様がまだ承認する前であれば、ドニー様に提供実績ページから「拒否」の操作をしていただくことで無効にできます。メッセージにてお相手にご連絡ください。</p>
            </li>
            <li>
              <h4 className="sub_title" id="help-review"><span>Q</span>レビューとは何ですか？</h4>
              <p>レビューは、ドニーがドナーに対して評価とコメントを投稿できる機能です。精子提供を受けたドニーは、ドナーの対応や印象について1〜5つ星の評価とコメントを残すことができます。</p>
              <p>投稿されたレビューはドナーのプロフィールページに表示され、平均評価やレビュー数、各レビューの詳細を確認できます。</p>
              <p>レビューを投稿するには、ドニーの本人確認が承認されている必要があります。また、レビューは承認済みの提供実績があるドナーに対してのみ投稿できます。</p>
              <p><Link to="/donee_mypage/reviews" className="txt_blue">レビュー管理ページ</Link>(要ログイン)にて、ドニーは自身が投稿したレビューの編集や削除ができます。また、ドナーは自身のプロフィール画面にレビューを表示する/しないを設定できます。（個別のレビューを削除や非表示にすることはできません）</p>
            </li>
          </ul>

          <h2 id="faq-account" className="main_title"><span>アカウントについて</span></h2>
          <ul className="text_list">
            <li>
              <h4 className="sub_title"><span>Q</span>新規登録しようとすると「登録に失敗しました。時間をおいて再度お試しください」と表示されます</h4>
              <p>以下の可能性が考えられます。ご確認ください。</p>
              <p>
                ・すでに同じメールアドレスでアカウントが作成されている場合があります。<Link to="/login" className="txt_blue">ログインページ</Link>からログインをお試しいただくか、パスワードをお忘れの場合は再設定をお試しください。<br/>
                ・以前に仮登録（メール内のリンクからの本登録が未完了）のまま放置されている場合があります。<br/>
                ・過去に同じメールアドレスで登録し退会された場合、同一のメールアドレスでの再登録はできません。お手数ですが別のメールアドレスでご登録ください。
              </p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>アカウントは複数作成できますか？</h4>
              <p>いいえ、お一人様につき1アカウントのみご利用いただけます。複数アカウントの作成・利用が確認された場合、アカウントの利用停止などの措置を取らせていただく場合がございますのでご注意ください。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>パスワードを忘れた場合はどうすればいいですか？</h4>
              <p><Link to="/password/forgot" className="txt_blue">ログインページ</Link>の「パスワードをお忘れの方はこちら」からパスワードの再設定が可能です。ご登録のメールアドレスに再設定用のURLをお送りします。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>メール通知が届きません</h4>
              <p>まず迷惑メールフォルダをご確認ください。それでも届かない場合は、<Link to="/mypage/account" className="txt_blue">アカウント設定ページ</Link>でご登録のメールアドレスが正しいかご確認ください。解決しない場合はお問い合わせフォームよりご連絡ください。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>メールアドレスを変更したい</h4>
              <p><Link to="/mypage/account" className="txt_blue">アカウント設定ページ</Link>のメールアドレス欄から変更が可能です。変更後、新しいメールアドレスに確認メールが送信されますので、メール内のリンクをクリックして変更を完了させてください。</p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>退会はできますか？</h4>
              <p>退会は<Link to="/mypage/account"
                  className="txt_blue">アカウント設定ページ</Link>（要ログイン）の「退会する」ボタンからいつでも可能です。<br/>退会した場合は、検査の審査結果を含めてご登録いただいた情報を復元できませんのでご了承ください。
              </p>
            </li>
            <li>
              <h4 className="sub_title"><span>Q</span>お問い合わせフォームはありますか？</h4>
              <p>
                解決しない場合は、
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLScGv-6GgDw8_xLOmch7yv7UGm7wgr64T7DYwhxMjZx3p8qHSg/viewform"
                  className="txt_blue"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  こちら
                </a>
                からお問い合わせください。
              </p>
            </li>
          </ul>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default FaqPage;
